export default {
  name: 'MCard',
  props: {
    edit: Boolean,
    headerText: {
      type: String,
    },
    closed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    show: false,
  }),
  watch: {
    closed: {
      handler(val) {
        this.show = val;
      },
      immediate: true,
    },
  },
  computed: {
    canEdit() {
      if (this.edit) {
        return true;
      }
      return false;
    },
  },
  methods: {
    handleShowClick() {
      this.show = !this.show;
      this.$emit('show', !this.show);
    },
  },
};
